import React, { ReactNode, useCallback, useEffect, useRef, useState } from "react";
import { Box, Text } from "rebass";

import { ControlButton } from "../styled/ControlButton";
import { Popover } from "./Popover";

import { AlphaBetSVG } from "../svg/AlphaBetSVG";
import { SpeedSVG } from "../svg/SpeedSVG";
import { TranslateSVG } from "../svg/TranslateSVG";

import { ControlType } from "./ControlType";

interface IProps {
  children: ReactNode;
  controlType: ControlType;
}

const BUTTON_ICON = {
  voice: TranslateSVG,
  display: AlphaBetSVG,
  speed: SpeedSVG,
};

const EVENT_TYPE = "mousedown";

const ControlPopover: React.FC<IProps> = ({ children, controlType }) => {
  const Icon = BUTTON_ICON[controlType];
  const wrapperRef = useRef<HTMLDivElement>();
  const [isOpen, setIsOpen] = useState(false);
  const handleOutside = useCallback(({ target }) => {
    const { current } = wrapperRef;

    if (current && !current.contains(target)) {
      setIsOpen(false);
    }
  }, []);
  const toggleIsOpen = useCallback(() => {
    setIsOpen(prevState => !prevState);
  }, []);
  /* add event listener to window "mousedown" */
  useEffect(() => {
    if (isOpen) {
      window.addEventListener(EVENT_TYPE, handleOutside);
    } else {
      window.removeEventListener(EVENT_TYPE, handleOutside);
    }

    return () => {
      window.removeEventListener(EVENT_TYPE, handleOutside);
    };
  }, [isOpen, handleOutside]);

  return (
    <Box
      ref={wrapperRef}
      mx="5px"
      css="position: relative;"
    >
      <ControlButton
        isOpen={isOpen}
        onClick={toggleIsOpen}
        color="sp-blue"
      >
        <Icon />

        <Text
          fontSize="12px"
          color="wild-blue-50"
          css="text-transform: capitalize;"
        >
          {controlType}
        </Text>
      </ControlButton>

      <Popover isOpen={isOpen}>{children}</Popover>
    </Box>
  );
};

export { ControlPopover, ControlType };
